// extracted by mini-css-extract-plugin
export var Backdrop = "style-module--Backdrop--22a80";
export var LogoWrapper = "style-module--LogoWrapper--040d0";
export var SplashScreen = "style-module--SplashScreen--bd73a";